module.exports = __webpack_public_path__ + "media/components/insights/asset-icons/equipment-8c4131754b63ee6c9f5765225095faa7.png";